import { FC } from "react";
import { useContent } from "@/hooks/useContent";
import ThemeToggleButton from "./ThemeToggleButton";

type AuthThemeToggleProps = {
  id?: string;
  className?: string;
};

const AuthThemeToggle: FC<AuthThemeToggleProps> = ({ id, className }) => {
  const { t } = useContent();

  return (
    <ThemeToggleButton
      id={id}
      className={className}
      switchToLightLabel={t("auth.theme.toLight")}
      switchToDarkLabel={t("auth.theme.toDark")}
    />
  );
};

export default AuthThemeToggle;
